import React from 'react'
import styles from './pupil-head.styles'
import injectSheet from 'react-jss'
import Head from '../../../head/head'
import Nav from './nav/nav'
import Title from './title/title.container'
import BackToPupils from '../../../back-to-pupils/back-to-pupils'
import Bone from 'pobble-components/dist/bone'
import classNames from 'classnames'

const PupilHead = ({ classes, showLoadingScreen, showPupilHead }) => (
  <Head
    className={classNames({ [classes.loadingContainer]: showLoadingScreen })}>
    {showPupilHead && <Title />}
    {showLoadingScreen && <Bone style={{ width: '180px', height: '38px' }} />}
    <Nav className={classes.navContianer} />
    <BackToPupils className={classes.backToPupils} />
  </Head>
)

export default injectSheet(styles)(PupilHead)
